import {Injectable} from '@angular/core';

@Injectable()
export class ErrorMessageService {
  public message: string = '000: Undefined error.';
  public status: number = 200;

  setError(status: number, obj: any) {
    this.status = status;
    this.set(obj);
  }

  set(obj: any) {
    if (typeof obj === 'string') {
      this.message = '<i>ERROR:</i> ' + this.status + ' ' + obj;
    } else {
      this.message = '<i>ERROR:</i> ' + this.status ;
      if (obj) {
        let i: number = 0;
        for (const [item, value] of Object.entries(obj)) {
          if (i === 0) {
            this.message += ' ';
          } else {
            this.message += '<br/>';
          }
          this.message += `<i>${item}:</i> ${value}`;
          i++;
        }
      } else {
        this.message += '<br/>No message found on error payload.';
      }
    }
  }
}
